import { render, staticRenderFns } from "./EntriesWarehouseDonut.vue?vue&type=template&id=2a5fd596"
import script from "./EntriesWarehouseDonut.vue?vue&type=script&lang=js"
export * from "./EntriesWarehouseDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports